import React from 'react';
import cx from 'classnames';
import Typing from 'react-typing-animation';
import { cep } from '../../../../utils/mask';
import { Address } from './types';

export const AddressMobile = ({ address, hasSeeAddress, addressDataValue }: Address) => {
  const { city, cepAddress, district, street, additionalAddressData } = address;

  const addressFirst = `${street}`;
  const addressSecond = `${additionalAddressData ? `${additionalAddressData} - ` : ''}${district},`;
  const restAddressTExt = `${city}, ${cep(cepAddress)}`;
  const truncateAddressText = addressFirst.slice(0, 8);
  const text = addressFirst.slice(8, addressFirst.length);
  const hasAddress = cx({ truncate: !hasSeeAddress });
  const commonStyle = cx('gtmSeeAdress f14 abbey fw3 ma0', hasAddress);
  return hasSeeAddress ? (
    <div className="flex relative pb32">
      <Typing hideCursor speed={10}>
        <p data-value={addressDataValue} className={commonStyle}>
          {truncateAddressText} {text}
        </p>

        <Typing.Delay ms={20} />
        <p data-value={addressDataValue} className={cx('absolute left-0', commonStyle)}>
          {addressSecond}
        </p>
        <Typing.Delay ms={30} />
        <p data-value={addressDataValue} className={cx('absolute left-0 bottom-0', commonStyle)}>
          {restAddressTExt}
        </p>
      </Typing>
    </div>
  ) : (
    <p className={commonStyle}>{addressFirst}</p>
  );
};
